import { Component } from '@theme/component';

/**
 * Shop by Category carousel.
 * Desktop: progress bar + arrow navigation.
 * Mobile: swipe + progress bar.
 *
 * @extends Component<{ track: HTMLElement, prevBtn?: HTMLElement, nextBtn?: HTMLElement, progressBar?: HTMLElement }>
 */
class PvCategories extends Component {
  requiredRefs = ['track'];

  #prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  connectedCallback() {
    super.connectedCallback();
    const { prevBtn, nextBtn, track } = this.refs;

    prevBtn?.addEventListener('click', () => this.#scroll(-1));
    nextBtn?.addEventListener('click', () => this.#scroll(1));
    track.addEventListener('scroll', this.#onScroll, { passive: true });

    this.#syncState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const { track } = this.refs;
    if (!track) return;
    track.removeEventListener('scroll', this.#onScroll);
  }

  #onScroll = () => this.#syncState();

  #scroll(direction) {
    const { track } = this.refs;
    const card = track.querySelector('.pv-categories__card');
    if (!card) return;

    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const amount = card.offsetWidth + gap;

    track.scrollBy({
      left: direction * amount,
      behavior: this.#prefersReduced ? 'auto' : 'smooth',
    });

    setTimeout(() => this.#syncState(), 350);
  }

  #syncState() {
    const { track, prevBtn, nextBtn, progressBar } = this.refs;
    if (!track) return;

    const { scrollLeft, scrollWidth, clientWidth } = track;
    const maxScroll = scrollWidth - clientWidth;

    prevBtn?.setAttribute('aria-disabled', scrollLeft <= 0 ? 'true' : 'false');
    nextBtn?.setAttribute('aria-disabled', scrollLeft >= maxScroll - 1 ? 'true' : 'false');

    if (progressBar && maxScroll > 0) {
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const offset = (scrollLeft / maxScroll) * (100 - thumbWidth);
      progressBar.style.width = `${thumbWidth}%`;
      progressBar.style.marginLeft = `${offset}%`;
    }
  }
}

if (!customElements.get('pv-categories')) {
  customElements.define('pv-categories', PvCategories);
}
